/**
 * @fileoverview Contiene aciones, estados, getters, modulos y mutaciones
 * del store de Clientes
 *
 * @version 1.0
 *
 * @author José Antonio Rodríguez Barceló
 *
 * @copyright Shuttle Express México
 *
 * Historial
 * ---------
 * La primera versión fue escrita por José Antonio Rodríguez Barceló
 */

import ClientServices from './client.services'
export const namespaced = true

export const actions = {
  /**
   * @name fetchMailClient
   * @description Obtiene un Cliente por su Correo
   *
   * @param {*} context _ Para hacer referencia al objeto en el que se ejecuta la función
   * @param {*} payload Parametros para poblar el select
   */
  fetchClient(_, payload) {
    return ClientServices.getClient(payload.correo)
  },

  /**
   * @name fetchClients
   * @description Obtiene una lista de Clientes
   *
   * @param {*} context _ Para hacer referencia al objeto en el que se ejecuta la función
   * @param {*} payload Parametros para poblar el select
   */
  fetchClients(_, payload) {
    let params = 'params' in payload ? payload.params : null
    return ClientServices.getClient(params)
  },

  /**
   * @name fetchClientsByQuery
   * @description Obtiene un Cliente basado en una consulta
   *
   * @param {*} context _ Para hacer referencia al objeto en el que se ejecuta la función
   * @param {*} payload Parametros para poblar el select
   */
  fetchClientByQuery(_, payload) {
    return ClientServices.getByQuery(payload)
  },

  /**
   * @name addClient
   * @description Crea un nuevo Cliente
   *
   * @param {*} context _ Para hacer referencia al objeto en el que se ejecuta la función
   * @param {*} payload Parametros para crear un Cliente
   */
  addClient(_, payload) {
    return ClientServices.postClient(payload.body)
  },

  /**
   * @name editClient
   * @description Edita un Cliente
   *
   * @param {*} context _ Para hacer referencia al objeto en el que se ejecuta la función
   * @param {*} payload Parametros para editar un Cliente existente
   */
  editClient(_, payload) {
    return ClientServices.patchClient(payload.body, payload.id)
  },

  /**
   * @name deleteClient
   * @description Elimina un Cliente
   *
   * @param {*} context _ Para hacer referencia al objeto en el que se ejecuta la función
   * @param {*} payload Parametros para eliminar un Cliente
   */
  deleteClient(_, payload) {
    return ClientServices.deleteClient(payload.id)
  },
}
